import React from 'react'
import { Navigate } from 'react-router-dom'
import '../../../css/public/pages/login.css'
import Form from './form';

const Index = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    if(User){
        if(User.role === 'admin'){
            return <Navigate to={'/admin'}/>
        }
        else if(User.role === 'labadmin'){
            return <Navigate to={"/labadmin"}/>
        }
        else if(User.role === 'doctor'){
            return <Navigate to={"/doctor"}/>
        }
        else{
            return <Navigate to={"/"}/>
        }
    }
    else{
        return (
          <Form/>
        )
    }
}

export default Index
